import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/platform/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 删除
export function deleteInfo(driverId) {
  return request.send({
    url: `/pmy/sys/driver?driverId=${driverId}`,
    method: "delete",
  });
}
// 设置在跑
export function setRunOrStop(data) {
  return request.send({
    url: `/pmy/sys/driver/status`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 历史申请记录
export function getHistory(data) {
  return request.send({
    url: `/pmy/sys/driver/apply-history`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

//
// 录入司机信息
export function saveDriverInfo(data) {
  return request.send({
    url: `/pmy/sys/driver`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑司机信息
export function editDriverInfo(data) {
  return request.send({
    url: `/pmy/sys/driver`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 重置司机密码
export function resetDriverPassword(data) {
  return request.send({
    url: `/pmy/sys/driver/reset-pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

export function detailInfo(driverId) {
  return request.send({
    url: `/pmy/sys/driver/info?driverId=${driverId}`,
    method: "get"
  });
}
// 导出
export function downloadTable(data) {
  return request.send({
    url: `/pmy/sys/driver/platform/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
